import React, {Component} from 'react';
import Header from '../components/Header';
import Inner from '../components/Inner';

export default class About extends Component {
    render() {
        return (
            <div>
                <Header title="Om Frist&shy;beregneren"/>
                <Inner>
                    <div className="mainContainer">
                        <div className="mainContainerText">
                            <p>Fristberegneren er et simpelt værktøj, der nemt og hurtigt kan hjælpe dig med at beregne
                                minimumsfrister i udbud.</p>
                            <p>Beregning af minimumsfrister er i vidt omfang en ren matematisk øvelse og egner sig derfor til at
                                ”blive sat på formel”. Der vil dog kunne opstå tvivl om, hvordan en frist konkret skal beregnes,
                                f.eks. om betingelserne for fristforkortelse er opfyldt. Ligeledes er det vigtigt at være
                                opmærksom
                                på, at Fristberegneren alene beregner minimumsfrister, og at det efter omstændighederne kan være
                                påkrævet med en længere frist, f.eks. fordi der er tale om et komplekst udbud.</p>
                            <p>Fastsættelse af en for kort frist kan have alvorlige udbudsretlige konsekvenser, og du bør derfor
                                altid overveje at søge rådgivning, hvis du er i tvivl om, hvor lang en
                                given
                                frist skal eller bør være.</p>
                            <p>Har du spørgsmål eller bemærkninger til brugen af Fristberegneren, herunder forslag til
                                forbedringer,
                                tilføjelse af nye funktioner eller lignende, er du meget velkommen til at <a
                                    href="mailto:fristberegneren@poulschmith.dk">kontakte</a> os.</p>
                            <p>Fristberegneren er udviklet og udtænkt af advokat <a
                                href="https://kammeradvokaten.dk/personer/niels-karl-heilskov-rytter/" target="_blank">Niels
                                Karl Heilskov Rytter</a>.
                            </p>
                        </div>
                    </div>
                </Inner>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/views/About.js